'use strict';exports.__esModule = true;var validateVirtual = exports.validateVirtual = function validateVirtual(values, props) {
  var errors = {};

  if (!values.primary) {
    errors.primary = 'required';
  }

  if (values.primary && values.secondary && values.primary.value === values.secondary.value) {
    errors.primary = 'differentContacts';
    errors.secondary = 'differentContacts';
  }

  return errors;
};exports.default =


validateVirtual;


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/VirtualNumbersForm/validate.js
// module id = 2944
// module chunks = 0